'use strict';

var BidPriceGraphDirective = function BidPriceGraphDirective(bidPriceGraphChart, ChartModel) {
  return {
    restrict: 'EC',
    replace: true,
    template: require('../templates/bid-price-graph.html'),
    controller: 'BidPriceGraphController',
    scope: {
      mode: '@',
      screen: '@'
    },
    link: function link(scope, element) {
      var chartModel = new ChartModel();
      var chart = bidPriceGraphChart(element, chartModel, scope.screen, scope.mode);
      scope.renderChart = function () {
        chartModel.data(scope.data);
        updateSelectedOptions();
        chart.render();
      };
      function updateSelectedOptions() {
        scope.selectedOptions = {
          leg: chartModel.leg(),
          cabin: chartModel.cabinCode()
        };
      }
      scope.$on(scope.screen + ':scenariosChanged', scope.retrieveData);
    }
  };
};
BidPriceGraphDirective.$inject = ['AVRO.BidPriceGraph.Chart', 'AVRO.BidPriceGraph.ChartModel'];
module.exports = BidPriceGraphDirective;